import { observer } from "mobx-react-lite";
import { useExonnHubStore } from "src/admin/modules/b2b-gate-order/components/ExonnHub/useExonnHubStore.ts";
import * as styles from "./Header.style.ts";
import { Flex } from "src/components/Flex.tsx";
import { IconButtonV2 } from "src/components/IconButtonV2/IconButtonV2.tsx";
import { SearchBar } from "src/admin/modules/b2b-gate-order/components/ExonnHub/components/SearchBar/SearchBar.tsx";
import { ViewAddedProductsButton } from "src/admin/modules/b2b-gate-order/components/ExonnHub/components/ContentView/ViewAddedProductsButton/ViewAddedProductsButton.tsx";
import { TooltipV2 } from "src/components/TooltipV2/TooltipV2.tsx";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useIsDemoShop } from "src/hooks/use-is-demo-shop.ts";

export const Header = observer(({ onRefresh }: { onRefresh: () => void }) => {
  const store = useExonnHubStore();
  const isFullscreen = store.isFullscreen;
  const { t } = useTranslation(TranslationNamespaceEnum.ExonnHubComponent);
  const isDemoShop = useIsDemoShop();
  return (
    <div css={styles.header}>
      <Flex gap={10} alignItems={"center"}>
        <IconButtonV2
          onClick={onRefresh}
          size={"sm"}
          variant={"outlined"}
          skin={"info"}
        >
          <span className={"icon-15-update"} />
        </IconButtonV2>
        <SearchBar />
      </Flex>
      {!isDemoShop && (
        <Flex gap={15} alignItems={"center"}>
          <ViewAddedProductsButton />
          <TooltipV2
            content={
              isFullscreen ? t("exitFullscreenMode") : t("enterFullscreenMode")
            }
          >
            <IconButtonV2
              onClick={() => {
                store.toggleFullscreen();
              }}
              size={"sm"}
              skin={"info"}
              variant={"outlined"}
            >
              {isFullscreen ? (
                <i className={"icon-15-full_scrn_cls"} />
              ) : (
                <i className={"icon-15-full_scrn"} />
              )}
            </IconButtonV2>
          </TooltipV2>
        </Flex>
      )}
    </div>
  );
});
